import moment, { MomentInput } from 'moment';
import withStyles from '@material-ui/core/styles/withStyles';

export { default as PlanSlick } from './Slick';
export { default as LocationSubheader } from './LocationSubheader';

export const ContentSummary = withStyles(require('./ContentSummary').styles)(
  require('./ContentSummary').default,
);

export const MIN_IMAGE_NUMBER = 4;
export const IMAGE_LIMIT = 10;

type getScheduleTimeTextArgs = {
  startTime: MomentInput;
  endTime: MomentInput;
  format?: string;
};

export function getScheduleTimeText({
  startTime,
  endTime,
  format = 'HH:mm',
}: getScheduleTimeTextArgs) {
  const sMoment = moment(startTime);
  const eMoment = moment(endTime);
  if (sMoment.isValid() && eMoment.isValid()) {
    return [sMoment.format(format), eMoment.format(format)].join(' - ');
  } else if (sMoment.isValid()) {
    return `${sMoment.format(format)} - `;
  }
  return '';
}
